import { render } from "./MotorizePage.vue?vue&type=template&id=d8d202ca&scoped=true"
import script from "./MotorizePage.vue?vue&type=script&lang=js"
export * from "./MotorizePage.vue?vue&type=script&lang=js"

import "./MotorizePage.vue?vue&type=style&index=0&id=d8d202ca&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d8d202ca"]])

export default __exports__